import {IssueTypeToken} from '@github-ui/issue-type-token'
import type {IssueTypePickerIssueType} from '@github-ui/item-picker-issue-type'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './IssueType.module.css'

type IssueTypeProps = {
  type?: IssueTypePickerIssueType | null
  repoNameWithOwner?: string
  anchorProps?: React.HTMLAttributes<HTMLElement>
}

export function IssueType({type, anchorProps, repoNameWithOwner}: IssueTypeProps) {
  return (
    <>
      {type ? (
        <div data-testid={TEST_IDS.typeContainer} className={styles.IssueTypeToken}>
          <IssueTypeToken
            name={type.name}
            color={type.color}
            href={`/${repoNameWithOwner}/issues?q=type:"${type.name}"`}
            getTooltipText={(isTruncated: boolean) => (isTruncated ? type.name : undefined)}
          />
        </div>
      ) : (
        <div className={styles.hiddenPlaceholder} {...anchorProps} />
      )}
    </>
  )
}

try{ IssueType.displayName ||= 'IssueType' } catch {}